import { render } from "./ChartRender.vue?vue&type=template&id=97d44062&ts=true"
import script from "./ChartRender.vue?vue&type=script&lang=ts"
export * from "./ChartRender.vue?vue&type=script&lang=ts"

import "./ChartRender.vue?vue&type=style&index=0&id=97d44062&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__